export default __webpack_public_path__ + "static/media/logoMtto.e22362a4.png";